import { useMutation, useQueryClient } from 'react-query'
import ProjectService from '../../../services/ProjectService'

type DeleteProjectPayload = {
  organization: string
  selectedProjects: string[]
}
export const useProjectBulkDelete = () => {
  const queryClient = useQueryClient()

  return useMutation<any, Error, DeleteProjectPayload>({
    mutationKey: ['bulk-delete-project'],
    mutationFn: async ({ organization, selectedProjects }) => {
      await Promise.all(selectedProjects.map((name) => ProjectService.deleteProject(organization, name)))
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['projects'] })
      queryClient.invalidateQueries({ queryKey: ['projects-structure'] })
    },
  })
}
